import React from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";

// Actions
import { deleteDocument } from "repository/actions/data/dashboard/documents";

export default withSnackbar(
  withRouter(function (props) {
    const {
      isOpen,
      setClose,
      itemId,
      documents,
      setDocuments,
      user,
      getStudent,
      setStudent,
      student,
    } = props;
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteItem = () => {
      if (user && user != null) {
        setSaveLoading(true);

        deleteDocument(itemId, documents, setDocuments, user.idToken)
          .then((result) => {
            getStudent(student._id, user.idToken).then((getStudentResult) => {
              setStudent(getStudentResult);
              toast.success("Successfully deleted document.");
              setClose();
              setSaveLoading(false);
            });
          })
          .catch((error) => {
            toast.error(
              "Oops! Something went wrong. Check that you have the correct information"
            );
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Delete selected document"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteItem()}
        actionButtonTitle="Yes, I'm sure"
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to delete this document?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
